export function showImagePopup(src: string, alt: string, closeLabel?: string) {
  const overlay = document.createElement('div');
  overlay.className = 'image-popup-overlay';

  const figure = document.createElement('div');
  figure.className = 'image-popup-figure';

  const img = document.createElement('img');
  img.className = 'image-popup-content';
  img.src = src;
  img.alt = alt;

  figure.appendChild(img);

  if (alt) {
    const caption = document.createElement('div');
    caption.className = 'image-popup-caption';
    caption.textContent = alt;
    figure.appendChild(caption);
  }

  const closeBtn = document.createElement('button');
  closeBtn.className = 'image-popup-close';
  closeBtn.type = 'button';
  closeBtn.innerHTML = '&times;';
  closeBtn.setAttribute('aria-label', closeLabel || 'Close');

  overlay.appendChild(figure);
  overlay.appendChild(closeBtn);
  document.body.appendChild(overlay);
  document.body.classList.add('has-modal');

  const closePopup = () => {
    document.body.classList.remove('has-modal');
    overlay.remove();
    document.removeEventListener('keydown', handleKeyDown);
  };

  const handleKeyDown = (event: KeyboardEvent) => {
    if (event.key === 'Escape') {
      closePopup();
    }
  };

  overlay.addEventListener('click', (event) => {
    if (event.target instanceof Node && figure.contains(event.target)) {
      return;
    }
    closePopup();
  });

  closeBtn.addEventListener('click', (event) => {
    event.stopPropagation();
    closePopup();
  });

  document.addEventListener('keydown', handleKeyDown);
}

/**
 * 編集中のリンクをタップした際に表示する Google Keep 風のツールチップポップアップ。
 * リンク要素の近くにボタンを表示し、押すと新規タブで URL を開く（open を渡せば、その動作に替える）。
 */
export function showLinkOpenPopup(
  linkEl: HTMLAnchorElement,
  label: string,
  open: () => void = () => window.open(linkEl.href, '_blank', 'noopener')
) {
  // 既存のリンクポップアップがあれば閉じる
  const existing = document.querySelector('.link-open-popup');
  if (existing) {
    existing.remove();
  }

  const href = linkEl.href;
  const rect = linkEl.getBoundingClientRect();

  const popup = document.createElement('div');
  popup.className = 'link-open-popup';
  popup.setAttribute('role', 'tooltip');

  const openBtn = document.createElement('button');
  openBtn.className = 'link-open-popup-btn';
  openBtn.type = 'button';
  openBtn.textContent = label;
  openBtn.title = href;

  popup.appendChild(openBtn);
  document.body.appendChild(popup);

  // 位置をリンクの直下に設定（画面外にはみ出ないよう調整）
  const popupRect = popup.getBoundingClientRect();
  let top = rect.bottom + window.scrollY + 6;
  let left = rect.left + window.scrollX;

  const rightEdge = left + popupRect.width;
  if (rightEdge > window.innerWidth - 8) {
    left = window.innerWidth - popupRect.width - 8;
  }
  if (left < 8) {
    left = 8;
  }

  popup.style.top = `${top}px`;
  popup.style.left = `${left}px`;

  const closePopup = () => {
    popup.remove();
    document.removeEventListener('pointerdown', handleOutsideClick, true);
    document.removeEventListener('keydown', handleKeyDown);
  };

  const handleOutsideClick = (event: PointerEvent) => {
    if (!popup.contains(event.target as Node)) {
      closePopup();
    }
  };

  const handleKeyDown = (event: KeyboardEvent) => {
    if (event.key === 'Escape') {
      closePopup();
    }
  };

  openBtn.addEventListener('click', (event) => {
    event.stopPropagation();
    closePopup();
    open();
  });

  // Escape は開いた直後から効かせる。遅らせると、出てすぐ押した Escape を取りこぼす。
  document.addEventListener('keydown', handleKeyDown);
  // 外部クリック検知だけは少し遅らせる（今のクリックが伝播し終わるのを待つ）
  setTimeout(() => {
    document.addEventListener('pointerdown', handleOutsideClick, true);
  }, 0);
}
